<template>
	<nk-box
		v-if="context && context.kontaktperson && context.kontaktperson.vorname"
		variant="sidebar"
	>
		<nk-meta>Ihr Ansprechpartner</nk-meta>
		<nk-title
			v-if="context.kontaktperson.vorname && context.kontaktperson.nachname"
			size="lg"
			class="mt-4"
		>
			<nk-link
				v-if="context.taggingpfad"
				block
				:link="`${
					context.taggingpfad.slice(-1) !== '/'
						? context.taggingpfad + '/'
						: context.taggingpfad
				}${
					$slugify(
						context.kontaktperson.vorname +
							'-' +
							context.kontaktperson.nachname,
					) +
					'-id_' +
					context.kontaktperson.id
				}`"
			>
				{{ context.kontaktperson.vorname }}
				{{ context.kontaktperson.nachname }}
			</nk-link>
			<template v-else>
				{{ context.kontaktperson.vorname }}
				{{ context.kontaktperson.nachname }}
			</template>
		</nk-title>

		<nk-wrapper>
			<div
				v-if="context.kontaktperson.funktion"
				v-html="context.kontaktperson.funktion"
			/>
		</nk-wrapper>

		<nk-address
			v-if="context.kontaktperson.kommunikationsmoeglichkeiten"
			variant="vertical"
			:email="
				context.kontaktperson.kommunikationsmoeglichkeiten &&
				context.kontaktperson.kommunikationsmoeglichkeiten.find(
					kontaktArt => kontaktArt.kanal === 'EMAIL',
				)
					? context.kontaktperson.kommunikationsmoeglichkeiten.find(
							kontaktArt => kontaktArt.kanal === 'EMAIL',
						).kennung
					: null
			"
			:telefon="
				context.kontaktperson.kommunikationsmoeglichkeiten &&
				context.kontaktperson.kommunikationsmoeglichkeiten.find(
					kontaktArt => kontaktArt.kanal === 'TELEFON',
				)
					? context.kontaktperson.kommunikationsmoeglichkeiten.find(
							kontaktArt => kontaktArt.kanal === 'TELEFON',
						).kennung
					: null
			"
			:mobil="
				context.kontaktperson.kommunikationsmoeglichkeiten &&
				context.kontaktperson.kommunikationsmoeglichkeiten.find(
					kontaktArt => kontaktArt.kanal === 'MOBILTELEFON',
				)
					? context.kontaktperson.kommunikationsmoeglichkeiten.find(
							kontaktArt => kontaktArt.kanal === 'MOBILTELEFON',
						).kennung
					: null
			"
		/>
	</nk-box>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {object} context
 * @prop {object} context.kontaktperson
 * @prop {object} context.taggingpfad
 */
export default {
	name: 'NkSidebarServiceBwKontaktperson',

	mixins: [TemplatesDefault],
};
</script>
